import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import withShowHide from '@sparefoot/react-core/decorators/withShowHide';
import CSSTransition from 'react-transition-group/CSSTransition';

import { Button } from 'components/core/Button';

import './Tooltip.scss';

export const enhance = withShowHide('tooltip');

export function Tooltip({
	children, className, content, segmentLabel,
	onShowTooltip, onHideTooltip, tooltipShowing,
	last
}) {
	return (
		<div className={classnames('ss-tooltip', className, {
			last
		})}
		>
			<Button
				className="tooltip-trigger"
				segmentLabel={`tooltip ${segmentLabel}`}
				onMouseEnter={onShowTooltip}
				onMouseLeave={onHideTooltip}
			>
				{children}
			</Button>
			<CSSTransition
				in={tooltipShowing}
				timeout={300}
				classNames="transition-fade-in"
				unmountOnExit
			>
				<div className="tooltip-content">
					{content}
				</div>
			</CSSTransition>
		</div>
	);
}

Tooltip.propTypes = {
	content: PropTypes.node.isRequired,
	className: PropTypes.string,
	children: PropTypes.node,
	onShowTooltip: PropTypes.func.isRequired,
	onHideTooltip: PropTypes.func.isRequired,
	segmentLabel: PropTypes.string.isRequired,
	tooltipShowing: PropTypes.bool,
	last: PropTypes.bool
};

export default enhance(Tooltip);
